import React from "react";
import PropTypes from 'prop-types';

export default class Certificates extends React.PureComponent
{
    static propTypes = {
        certificates: PropTypes.oneOf([PropTypes.array, PropTypes.object]).isRequired,
        language: PropTypes.string.isRequired,
    };

    render() {
        if (!this.props.certificates) {
            return null;
        }
        let certificates = Array.isArray(this.props.certificates) ? this.props.certificates : Object.values(this.props.certificates);
        if (certificates.length === 0) {
            return null;
        }
        return (
            <div className="skills details-section">
                <h4>
                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 fas fa-award "}/>
                    {window.Translator.getSlug('Certificates', this.props.language)}
                </h4>
                <ul className={'ms-hover'}>
                    {certificates.map((certificate) => {
                        if (certificate.hasOwnProperty('cCertificate') && certificate.cCertificate) {
                            let locale = certificate.cCertificate.locale.find(locale => locale.lang === this.props.language);
                            if (locale !== null) {
                                return locale.name;
                            }
                        }
                        return certificate.name;
                    }).filter(certificate => !!certificate).map(certificate => {
                        return (<li>{certificate}</li>)
                    })}
                </ul>
            </div>
        );
    }
}